import { ExcludedCampaignTemplateProps } from '../types';
import { CampaignsRowContainer } from '../styles';
import { CampaignTooltip } from '../CampaignTooltip';
import {
  EXCLUDED_CAMPAIGN_TABLE_ROWS_ID,
  EXCLUDED_CAMPAIGN_ID_TEST_ID,
  EXCLUDED_CAMPAIGN_NAME_TEST_ID,
  EXCLUDED_CAMPAIGN_ERROR_TEST_ID,
} from '../constants';

export const ExcludedCampaign = ({ excludedCampaign }: ExcludedCampaignTemplateProps) => {
  return (
    <CampaignsRowContainer data-test={EXCLUDED_CAMPAIGN_TABLE_ROWS_ID} $isCloneable={false}>
      <CampaignTooltip
        maxWidth={65}
        text={excludedCampaign?.campaignId ?? ''}
        id={EXCLUDED_CAMPAIGN_ID_TEST_ID}
      />
      <CampaignTooltip
        maxWidth={550}
        text={excludedCampaign?.campaignName ?? ''}
        id={EXCLUDED_CAMPAIGN_NAME_TEST_ID}
      />
      <div data-test={EXCLUDED_CAMPAIGN_ERROR_TEST_ID}>{excludedCampaign?.errorMsg}</div>
    </CampaignsRowContainer>
  );
};
